import noty from '@/plugins/noty'

export const liveCoachMessageNotification = ({ name, message, onClick }) => {
  return noty({
    type: 'info',
    timeout: 10000,
    text: `${name}: ${message}`,
    closeWith: ['click', 'button'],
    callbacks: {
      onClick
    }
  })()
}



// WEBPACK FOOTER //
// ./src/components/shared/message-created/notifications.js